import React, { useState } from "react";
import styled from "styled-components";
import { FormattedMessage } from "react-intl";
import { FlexBox, Toolbox, P, Small, IconButtonDescription, IconButtonVideo } from "../../";
const Container = styled(FlexBox)`
  height: 75px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  cursor: pointer;
  color: ${props => props.theme.colors.action};
  z-index: 2;
  svg {
    margin-bottom: 4px;
    path {
      fill: ${props => props.theme.colors.action};
    }
  }
  &:hover {
    color: ${props => props.theme.colors.linkHover};
    text-decoration: underline;
    svg {
      path {
        fill: ${props => props.theme.colors.linkHover};
      }
    }
  }
`;
export const LearnMoreButton = ({
  highlight,
  video,
  ...props
}) => {
  if (!highlight && !video) {
    return null;
  }

  return React.createElement(Toolbox, {
    placement: "top",
    trigger: props => React.createElement(Container, props, video ? React.createElement(IconButtonVideo, null) : React.createElement(IconButtonDescription, {
      style: {
        flexShrink: 0
      }
    }), React.createElement(Small, {
      style: {
        whiteSpace: "nowrap"
      }
    }, React.createElement(FormattedMessage, {
      id: "label.learn_more",
      defaultMessage: "Learn More"
    })))
  }, video ? React.createElement("iframe", {
    width: "100%",
    src: `https://www.youtube.com/embed/${video}`,
    frameborder: "0",
    allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
    allowfullscreen: true
  }) : React.createElement(P, null, highlight));
};